import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import "../styles/LargeButton.css";

const LargeButton = ({ icon, name, desc, color = "#ff0000", onClick }) => {

    return (
        <div className="large-button" onClick={onClick} style={{background: color}}>
            <FontAwesomeIcon className="icon" icon={icon}/>
            <span className="name">{name}</span>
            <span className="desc">{desc}</span>
        </div>
    )
}

export default LargeButton;